import React, { useState } from 'react';
import MovieCard from './MovieCard';
import SearchBar from './SearchBar';

function MovieDatabase() {
  const [searchTerm, setSearchTerm] = useState('');
  const [favorites, setFavorites] = useState([]);
  const [showFavoritesOnly, setShowFavoritesOnly] = useState(false);

  const movies = [
    { id: 1, title: 'Dune', genre: 'Sci-Fi', year: 2021, rating: 8.0, director: 'Denis Villeneuve' },
    { id: 2, title: 'Parasite', genre: 'Thriller', year: 2019, rating: 8.6, director: 'Bong Joon-ho' },
    { id: 3, title: 'Spirited Away', genre: 'Animation', year: 2001, rating: 9.3, director: 'Hayao Miyazaki' },
    { id: 4, title: 'Mad Max: Fury Road', genre: 'Action', year: 2015, rating: 8.1, director: 'George Miller' },
    { id: 5, title: 'Moonlight', genre: 'Drama', year: 2016, rating: 7.4, director: 'Barry Jenkins' },
    { id: 6, title: 'Blade Runner 2049', genre: 'Sci-Fi', year: 2017, rating: 8.0, director: 'Denis Villeneuve' },
    { id: 7, title: 'The Grand Budapest Hotel', genre: 'Comedy', year: 2014, rating: 8.1, director: 'Wes Anderson' },
    { id: 8, title: 'Knives Out', genre: 'Mystery', year: 2019, rating: 7.9, director: 'Rian Johnson' },
    { id: 9, title: 'Everything Everywhere All at Once', genre: 'Sci-Fi', year: 2022, rating: 7.8, director: 'Daniels' },
    { id: 10, title: 'The Shape of Water', genre: 'Fantasy', year: 2017, rating: 7.3, director: 'Guillermo del Toro' },
    { id: 11, title: 'Nomadland', genre: 'Drama', year: 2020, rating: 7.3, director: 'Chloé Zhao' },
    { id: 12, title: 'Spider-Man: Into the Spider-Verse', genre: 'Animation', year: 2018, rating: 8.4, director: 'Bob Persichetti' }
  ];

  const toggleFavorite = (movieId) => {
    setFavorites(prev => 
      prev.includes(movieId) 
        ? prev.filter(id => id !== movieId)
        : [...prev, movieId]
    );
  };

  const handleReset = () => {
    setSearchTerm('');
    setShowFavoritesOnly(false);
  };

  const filteredMovies = movies.filter(movie => {
    const query = searchTerm.toLowerCase();
    const matchesSearch = !searchTerm || (
      movie.title.toLowerCase().includes(query) ||
      movie.genre.toLowerCase().includes(query) ||
      movie.director.toLowerCase().includes(query) ||
      movie.year.toString().includes(query)
    );
    const matchesFavorites = !showFavoritesOnly || favorites.includes(movie.id);
    return matchesSearch && matchesFavorites;
  });

  const favoriteMovies = movies.filter(movie => favorites.includes(movie.id));

  const renderContent = () => {
    if (showFavoritesOnly) {
      if (favorites.length === 0) {
        return (
          <div className="no-results">
            <h2>🎆 Your Watchlist is Empty</h2>
            <p>Discover amazing films and add them to your personal collection!</p>
            <button onClick={() => setShowFavoritesOnly(false)} className="try-again-btn">
              Explore Movies
            </button>
          </div>
        );
      }
      
      return (
        <>
          <div className="favorites-section">
            <h2>🎆 My Watchlist ({favoriteMovies.length})</h2>
          </div>
          <div className="movies-grid">
            {favoriteMovies.map(movie => (
              <MovieCard
                key={movie.id}
                movie={movie}
                onToggleFavorite={toggleFavorite}
                isFavorite={true}
              />
            ))}
          </div>
        </>
      );
    }

    if (!searchTerm) {
      return (
        <>
          <div className="welcome-message">
            <h2>🎬 Cinema Collection</h2>
            <p>Discover {movies.length} handpicked films from around the world!</p>
          </div>
          <div className="movies-grid">
            {movies.map(movie => (
              <MovieCard
                key={movie.id}
                movie={movie}
                onToggleFavorite={toggleFavorite}
                isFavorite={favorites.includes(movie.id)}
              />
            ))}
          </div>
        </>
      );
    }

    if (filteredMovies.length === 0) {
      return (
        <div className="no-results">
          <h2>🔍 No Films Found</h2>
          <p>Couldn't find any movies matching "{searchTerm}"</p>
          <button onClick={handleReset} className="try-again-btn">
            Browse All Films
          </button>
        </div>
      );
    }

    return (
      <>
        <div className="results-success">
          <h2>🎬 {filteredMovies.length} Film{filteredMovies.length !== 1 ? 's' : ''} Found</h2>
          <p>Results for "{searchTerm}"</p>
        </div>
        <div className="movies-grid">
          {filteredMovies.map(movie => (
            <MovieCard
              key={movie.id}
              movie={movie}
              onToggleFavorite={toggleFavorite}
              isFavorite={favorites.includes(movie.id)}
            />
          ))}
        </div>
      </>
    );
  };

  return (
    <div className="movie-database">
      <h1>Cinema Explorer</h1>
      
      <SearchBar 
        searchTerm={searchTerm}
        onSearch={setSearchTerm}
        onReset={handleReset}
      />
      
      <div className="controls">
        <button 
          className={`favorites-toggle ${showFavoritesOnly ? 'active' : ''}`}
          onClick={() => setShowFavoritesOnly(!showFavoritesOnly)}
        >
          {showFavoritesOnly ? 'Browse All' : 'My Watchlist'}
        </button>
        {favorites.length > 0 && (
          <span className="favorites-count">🎆 {favorites.length} in watchlist</span>
        )}
      </div>
      
      {renderContent()}
    </div>
  );
}

export default MovieDatabase;